export default __webpack_public_path__ + "static/media/hamburger-menu.f5b1a3f2.svg";